// Define the enum
export enum CustomerViewTabs {
  Product = "product",
  Subscription = "subscription",
  FeatureRequest = "featureRequest",
  RequestForAssistance = "requestForAssistance",
  Programs = "programs",
  Engagements = "engagements",
  Support = "support",
  CRMCustomerProduct = "crmCustomerProduct",
  RFACustomerProduct = "rfaCustomerProduct",
  CustomerEngagements = "customerEngagements",
  Partner = "partner",
  CustomerFeatureData = "features",
  Product2 = "productv2",
  ConsumptionRevenue = "consumptionRevenue",
  CommunityDetails = "communityDetails",
  CustomerHealth = "customerHealth",
  CustomerHealthOverview = "customerHealthOverview",
  CustomerHealthPurview = "customerHealthPurview",
  CustomerHealthMTP = "customerHealthMTP",
  CustomerHealthIntune = "customerHealthIntune",
  CustomerHealthViewByTenant = "customerHealthViewByTenant",
  CustomerHealthViewByTPID = "customerHealthViewByTPID",
  FeatureRequestViewByTenant = "featureRequestViewByTenant",
  FeatureRequestViewByTPID = "featureRequestViewByTPID",
  BaselineSecurityHealth = "tenantHealthAssessment"
}

export enum DropdownReducerType {
  LoadItems,
  UpdateSelectedItem
}
